import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './adminApi';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email.trim(), password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#2C3A28] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#EDEAE0] rounded-3xl p-8 shadow-xl">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-[#2C3A28]/60">Al Naturale</p>
        <h1 className="mt-2 text-center font-display text-3xl font-semibold text-[#2C3A28]">Admin Login</h1>
        <input
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
          className="mt-6 w-full rounded-xl border border-[#2C3A28]/15 bg-white px-4 py-3 text-[#2C3A28] outline-none focus:border-[#2C3A28]"
        />
        <input
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
          className="mt-3 w-full rounded-xl border border-[#2C3A28]/15 bg-white px-4 py-3 text-[#2C3A28] outline-none focus:border-[#2C3A28]"
        />
        {error && <p className="mt-3 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-5 w-full rounded-full bg-[#2C3A28] text-white py-3.5 font-semibold hover:bg-[#1f2a1c] transition-colors disabled:opacity-60"
        >
          {busy ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
